module.exports = __webpack_public_path__ + "img/7.08a82e2b.png";